import request from "@libs/base/request";

const getProvinceApi = async (params) =>
  request({
    url: "/core/province",
    params,
    method: "GET",
  });

const getDistrictApi = async (params) =>
  request({
    url: "/core/district",
    params,
    method: "GET",
  });

const getVillageApi = async (params) =>
  request({
    url: "/core/village",
    params,
    method: "GET",
  });

const getListAddressApi = async (params) =>
  request({
    url: "/v1/my-address/me",
    params,
    method: "GET",
    tokenClient: true,
  });

const createAddressApi = async (data) =>
  request({
    url: "/v1/my-address",
    data,
    method: "POST",
    tokenClient: true,
    msgSuccess: "successCreateAddress",
  });

const updateAddressApi = async (data, id) =>
  request({
    url: `/v1/my-address/${id}`,
    data,
    method: "PUT",
    tokenClient: true,
    msgSuccess: "successUpdateAddress",
  });

const deleteAddressApi = async (data) =>
  request({
    url: `/v1/my-address/${data?.id}`,
    data,
    method: "DELETE",
    tokenClient: true,
    msgSuccess: "successDeleteAddress",
  });

export {
  getProvinceApi,
  getDistrictApi,
  getVillageApi,
  getListAddressApi,
  createAddressApi,
  updateAddressApi,
  deleteAddressApi,
};
